export default "__VITE_ASSET__accf5a00__"